<template>
    <!-- Start Main Content -->
    <div
        class="main-content group-data-[sidebar-size=lg]:xl:ml-[calc(theme('spacing.app-menu')_+_16px)] group-data-[sidebar-size=sm]:xl:ml-[calc(theme('spacing.app-menu-sm')_+_16px)] px-4 group-data-[theme-width=box]:xl:px-0 ac-transition">

        <!-- Add notice form -->
        <div class="card p-4 lg:p-6">
            <h6 class="card-title">Add Staff</h6>
            <form>
                 <div class="grid grid-cols-12 gap-x-4 gap-y-5 mt-7 pt-0.5" v-on:keyup.enter="nextFocus">

                    <div class="col-span-full lg:col-span-4 leading-none">
                        <label for="" class="form-label">Biometeric ID *</label>
                        <input type="text" id="barcode" v-model="staff.bio_id" placeholder="Type Here"
                            class="form-input" required autocomplete="off">
                    </div>
                    <div class="col-span-full lg:col-span-4 leading-none">
                        <label for="" class="form-label">First Name *</label>
                        <input type="text" id="barcode" v-model="staff.firstname" placeholder="Type Here"
                            class="form-input" required autocomplete="off">
                    </div>
                    <div class="col-span-full lg:col-span-4 leading-none">
                        <label for="" class="form-label">Last Name *</label>
                        <input type="text" v-model="staff.lastname" placeholder="Type Here" class="form-input" required
                            autocomplete="off">
                    </div>

    


                    
                    <div class="col-span-full  lg:col-span-4 leading-none">
                        <label class="form-label">Gender *</label>
                        <select class="form-input" v-model="staff.gender">
                            <option DISABLED value="0">SELECT GENDER</option>

                            <option value="male">Male</option>
                            <option value="female">Female</option>

                            <!-- <option v-for="(item, index)  in packageList" :value="item.id">{{ item.name }}</option> -->
                             
                        </select>
                    </div> 



                    <div class="col-span-full lg:col-span-4 leading-none">
                        <label for="" class="form-label">Address *</label>
                        <input type="text" v-model="staff.address" placeholder="Type Here" class="form-input" required
                            autocomplete="off">
                    </div>





                        <!-- end -->



                    <!-- frsit city-->

                    <div class="col-span-full lg:col-span-4 leading-none">
                        <label for="" class="form-label">City *</label>
                        <input type="text" id="barcode" v-model="staff.city" placeholder="Type Here"
                            class="form-input" required autocomplete="off">
                    </div>

                    
                    <div class="col-span-full lg:col-span-4 leading-none">
                        <label for="" class="form-label">State *</label>
                        <input type="text" v-model="staff.state" placeholder="Type Here" class="form-input" required
                            autocomplete="off">
                    </div>



                    <div class="col-span-full lg:col-span-4 leading-none">
                        <label for="" class="form-label">Phone Number *</label>
                        <input type="number" v-model="staff.phonenumber" placeholder="Type Here" class="form-input" required
                            autocomplete="off">
                    </div>





                        <!-- end phone-->





                    <!-- frsit Email-->

                    <div class="col-span-full lg:col-span-4 leading-none">
                        <label for="" class="form-label">Email Address *</label>
                        <input type="text" id="barcode" v-model="staff.email" placeholder="Type Here"
                            class="form-input" required autocomplete="off">
                    </div>

                    
                    <div class="col-span-full lg:col-span-4 leading-none">
                        <label for="" class="form-label">Emergency Contact *</label>
                        <input type="number" v-model="staff.emergencycontact" placeholder="Type Here" class="form-input" required
                            autocomplete="off">
                    </div>



                    <div class="col-span-full lg:col-span-4 leading-none">
                        <label for="" class="form-label">Health issues *</label>
                        <input type="text" v-model="staff.healthissue" placeholder="Type Here" class="form-input" required
                            autocomplete="off">
                    </div>





                        <!-- end Health-->



                    
                    <div class="col-span-full lg:col-span-4 leading-none">
                        <label for="" class="form-label">Date Of Joining *</label>
                        <input type="date" v-model="staff.dateofjoining" placeholder="Type Here" class="form-input" required
                            autocomplete="off">
                    </div>



                    <div class="col-span-full lg:col-span-4 leading-none">
                        <label for="" class="form-label">Date Of Leaving *</label>
                        <input type="date" v-model="staff.dateofleaving" placeholder="Type Here" class="form-input" required
                            autocomplete="off">
                    </div>
                    <!-- <div class="col-span-full lg:col-span-4 leading-none">
                        <label for="" class="form-label">Category *</label>
                        <select class="form-input" v-model="staff.category">
                            <option DISABLED value="0">SELECT CaTEGORY</option>

                            <option value="personaltrainer">Personal Trainer</option>
                            <option value="yogatrainer">Yoga Trainer</option>
                            <option value="zoombatrainer">Zoomba Trainer</option>
                             
                        </select>
                    </div> -->
                    <div class="col-span-full lg:col-span-4 leading-none">
                        <label for="" class="form-label">Services *</label>
                        <select ref="serviceSelect" name="service_id[]" class="form-input"  multiple>
                            <option DISABLED value="0">Select Services</option>

                            <option v-for="service in serviceList" :value="service.id">{{service.name}}</option>
                             
                        </select>
                    </div>





                        <!-- end EndDate-->

                </div>
            </form>
            <button @click="save" id="saveBtn" class="btn b-solid btn-primary-solid px-5 cursor-pointer mt-6">
               {{ isEdit>0?'Update':'Add' }}  Staff
            </button>

        </div>
    </div>



</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import axios from 'axios';

export default {
    name: 'AddProduct',
    components: {

    },
    mounted() {
        const staffId = this.$route.query.id;

        if (staffId) {
            this.isEdit=staffId;
            this.fetchStaffData(staffId);
        }else
            this.getBasics();

        this.initSelect2();
        $(".form-input").on('keyup')
    },
    watch: {
    'staff.service_id'(newVal) {
            $(this.$refs.serviceSelect).val(newVal).trigger('change');
        }
  },
    data() {
        return {
            isAdd: 0,
            isEdit: 0,
            isDelete: 0,
            deleteId: 0,
            packageList: [],
            serviceList: [],
            // customer: { name: '', cat: '0', barcode: '', hsn: '', descr: '', gst: '5', unit: '', mrp: '0', prate: '0', salerate: '0', set_rate: '0', set_qty: '0', op_qty: 0 },
            // employees: { empname: '', emprole: '0', isMainAdmin: 0 },
            staff: { 

               bio_id:'',
                firstname: '',
                lastname:'',
                // date: '',
                gender: '',
                address: '',
                city: '',
                state: '',
                phonenumber: '',
                email: '',
                emergencycontact: '',
                healthissue: '',
                dateofjoining: '',
                dateofleaving: '', 
                // category:'',   
                service_id:[],        
            },



        }
    },
    created() {
        
    },
    methods: {
        fetchStaffData(id) {
            var self=this;
            axios.get(`getStaffData/${id}`)
                .then(response => {
                     self.staff = response.data.data; 
                     self.serviceList = response.data.services;
                }).then(()=>{
                    self.initSelect2();
                })
                .catch(error => {
                    console.error('Error fetching customer data:', error);
                });
        },
        initSelect2() {
            var self=this;
            this.$nextTick(() => {
                const serviceSelect = $(this.$refs.serviceSelect).select2({
                    placeholder: "Select Options",
                    allowClear: true
                });
                if(self.staff.service_id){
                    serviceSelect.val(self.staff.service_id).trigger('change');
                }
                // Sync changes back to Vue data
                $(this.$refs.serviceSelect).on("change", () => {
                    this.staff.service_id = $(this.$refs.serviceSelect).val();  // Correctly set service_id array
                });
            });
        },
        updateSelect2() {
      this.$nextTick(() => {
        // Destroy and reinitialize Select2
        if (this.$refs.serviceSelect) {
          $(this.$refs.serviceSelect).select2("destroy").off("change");
          this.initSelect2();
        }
      });
    },
        async getBasics() {
            var self = this;
            axios.post('getBasicForCustomer').then(function (response) {
                self.packageList = response.data.packages;
                self.serviceList = response.data.services;
                self.employees = response.data.userDetails;
            });
        },
        nextFocus(e) {
            try{
            const inputs = Array.from(e.target.form.querySelectorAll('input'));
            const index = inputs.indexOf(e.target);

            if (index < inputs.length) {
                try {
                    inputs[index + 1].focus();
                    inputs[index + 1].select();
                } catch (error) {
                    $("#saveBtn").focus();
                }
            }
            }catch(e){}
        },
        save() {
            var self = this;
            if (self.staff.firstname == '') 
                self.$swal("Product Name is Required");
            // else if (self.product.salerate == '') 
            //     self.$swal("Salerate is Required"); 
            else {
                self.$swal({
                    title: "Do You Want To Save?",
                    text: "Are you sure? ",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    confirmButtonText: "Yes"
                }).then((result) => { // <--
                    if (result.value) { // <-- if confirmed
                        axios.post('addstaff', this.staff)
                            .then(response => {
                                var msg = response.data.msg;
                                var isSuccess = response.data.status;
                                //self.packageList = response.data.cats;
                               // self.employees = response.data.userDetails;
                               // self.cat = { name: '', status: 'Active' };
                                if (isSuccess == 1) {
                                    self.staff = { bio_id:'',
                firstname: '',
                lastname:'',
                // date: '',
                gender: '',
                address: '',
                city: '',
                state: '',
                phonenumber: '',
                email: '',
                emergencycontact: '',
                healthissue: '',
                dateofjoining: '',
                dateofleaving: '', 
                // category:'',   
                service_id:[],   };
                                  //  $("#barcode").focus();
                                }


                                self.$swal(msg);

                            })
                            .catch(error => {
                                console.log('Error on Authentication: ' + error);
                            });
                    }
                });
            }

        }
    },
    beforeDestroy() {
    // Clean up Select2 to avoid memory leaks
    if (this.$refs.serviceSelect) {
      $(this.$refs.serviceSelect).select2("destroy").off("change");
    }
  },
    watch: {
        serviceList() {
            this.$nextTick(() => {
                // Reinitialize Select2 after memberList updates
                $(this.$refs.serviceSelect).select2('destroy').select2();
            });
        }
    }
}
</script>
